<template lang="pug">
b-modal.rooms-modal(
  :id="'rooms-modal'"
  size="xl"
  hide-footer
  @shown="onShown"
)
  template(slot="modal-title")
    | {{ data.name }}
    br
    | {{ data.address }}

  .loading.text-center(v-if="loading")
    i.fas.fa-spinner.fa-spin.fa-3x
  table
    thead
      tr
        th.px-4 {{ $t('room.number') }}
        th.px-4 {{ $t('room.floor') }}
        th.px-4 {{ $t('room.layout') }}
        th.px-4.text-right {{ $t('room.area') }}
        th.px-4 {{ $t('room.facilities') }}
    tbody
      tr(v-for="room in rooms")
        td.px-4.py-3 {{ room.number }}
        td.px-4.py-3 {{ room.floor }}
        td.px-4.py-3 {{ room.layout }}
        td.px-4.py-3.text-right {{ room.area }}
        td.px-4.py-3 {{ facilities(room) }}
</template>

<script>
import { api } from '@/api'

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      rooms: [],
      loading: true
    }
  },

  watch: {
    data() {
      this.rooms = []
      this.loading = true
    }
  },

  methods: {
    facilities(room) {
      return room.facilities.map(facility => this.$t(`facilities.${facility.code}`)).join(' / ')
    },

    onShown() {
      api.get(`properties/${this.data.id}/rooms`).then(response => {
        this.rooms = response.data.data
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rooms-modal {
  ::v-deep .modal-content {
    overflow: hidden;
  }

  ::v-deep .modal-header {
    border: none;
    padding: 25px;

    h5 {
      color: #313541;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 25px;
      margin-left: 23px;
      margin-top: 15px;
    }
  }

  ::v-deep .modal-body {
    padding: 0;
  }

  table {
    display: flex;
    flex-flow: column;
    height: 575px;
    max-width: 100%;
    width: 100%;
  }

  thead {
    display: table;
    flex: 0 0 auto;
    table-layout: fixed;
    width: 100%;
  }

  tbody {
    display: block;
    flex: 1 1 auto;
    overflow-y: scroll;
  }

  th {
    background: #fff;
    color: #7c91a7;
    font-size: 12px;
    font-weight: bold;
    padding-bottom: 15px;
  }

  tr {
    background: #fcfdfe;
    border-bottom: 1px solid #e7ecf4;
    display: table;
    table-layout: fixed;
    width: 100%;

    &:hover {
      background: #fcfdfe;
      border-bottom: 1px solid #e7ecf4;
      box-shadow: none;
    }
  }

  td {
    color: #313541;
    font-size: 14px;
  }

  td,
  th {
    width: 15%;

    &:first-of-type {
      padding-left: 50px !important;
    }

    &:last-of-type {
      padding-right: 50px !important;
      width: initial;
    }
  }

  .loading {
    background: rgba(255, 255, 255, 0.3);
    bottom: 0;
    left: 0;
    padding-top: 100px;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
